import { ProductComparisonProps } from '~/components/ProductComparison/models';
import { pageBlockMapper } from '~/mappers/pageBlock';

import { ProductComparisonBlock } from './models';

export const productComparisonMapper = ({
  pageBlock,
  featureLabels,
  ...rest
}: ProductComparisonBlock): ProductComparisonProps | null => {
  if (!featureLabels || !Array.isArray(featureLabels)) return null;
  let featureLabelsDict: { [key: string]: string } = {};

  featureLabelsDict = featureLabels.reduce((acc, item) => {
    if (item && typeof item === 'object' && 'key' in item && 'value' in item) {
      acc[item.key] = item.value;
    }

    return acc;
  }, {});

  const result: ProductComparisonProps = {
    pageBlock: pageBlockMapper(pageBlock),
    featureLabels: featureLabelsDict,
    ...rest,
  };

  return result;
};
